// extracted by mini-css-extract-plugin
export default {"credit_container":"MediaCreditGrid_credit_container__daiT+","credit_list":"MediaCreditGrid_credit_list__wR-qx","expand_button":"MediaCreditGrid_expand_button__QHoiO"};